export default "__VITE_ASSET__CsnzVGW3__"